import { HTMLAttributes } from 'react'
import { cn, createComponent } from '@lair-finance/util'
import { AssetIcon } from '@/shared/ui/Asset'
import { TouchableButton } from '@/shared/ui/TouchableButton'
import { SERVICE_LINKS } from '@lair-finance/config'

export type FooterProps = HTMLAttributes<HTMLDivElement>

export const Footer = createComponent<HTMLDivElement, FooterProps>(
  ({ className, ...props }, ref) => (
    <footer
      className={cn(
        'container max-w-none flex justify-between items-center h-[56px] md:h-[72px] bg-greyscale-700 border-t border-greyscale-600',
        className,
      )}
      ref={ref}
      {...props}
    >
      <div
        className={
          'inline-flex items-center gap-x-4 typo-caption-2 text-greyscale-300 [&>a]:inline-flex [&>a]:items-center [&>a]:gap-x-1 [&_span]:max-md:hidden'
        }
      >
        <a href={SERVICE_LINKS.TERMS} target={'_blank'}>
          <AssetIcon filename={'terms.png'} size={24} />
          <span>Terms</span>
        </a>
        <a href={SERVICE_LINKS.PRIVACY} target={'_blank'}>
          <AssetIcon filename={'privacy.png'} size={24} />
          <span>Privacy</span>
        </a>
        <a href={SERVICE_LINKS.DOCS} target={'_blank'}>
          <AssetIcon filename={'docs.png'} size={24} />
          <span>Docs</span>
        </a>
      </div>
      <div className={'inline-flex items-center'}>
        <TouchableButton size={40} as={'a'} href={SERVICE_LINKS.TWITTER} target={'_blank'}>
          <AssetIcon filename={'twitter.png'} size={24} />
        </TouchableButton>
        <TouchableButton size={40} as={'a'} href={SERVICE_LINKS.MEDIUM} target={'_blank'}>
          <AssetIcon filename={'medium.png'} size={24} />
        </TouchableButton>
        <TouchableButton size={40} as={'a'} href={SERVICE_LINKS.DISCORD} target={'_blank'}>
          <AssetIcon filename={'discord.png'} size={24} />
        </TouchableButton>
        <TouchableButton size={40} as={'a'} href={SERVICE_LINKS.GITHUB} target={'_blank'}>
          <AssetIcon filename={'github.png'} size={24} />
        </TouchableButton>
      </div>
    </footer>
  ),
  'Footer',
)
